document.addEventListener("DOMContentLoaded", function() {
  const itemsWithChild = document.querySelectorAll("header .item-w-child");
  const overlay = document.querySelector(".overlay__blur-background");


    function toggleOverlay() {
    const anyActive = document.querySelector("header .sub-menu.active");
    if (anyActive) {
      overlay?.classList.add("active");
    } else {
      overlay?.classList.remove("active");
    }
  }


  itemsWithChild.forEach(item => {
    item.addEventListener("mouseenter", function() {
       
      // Close all other sub-menus first
      document.querySelectorAll("header .sub-menu").forEach(menu => {
        menu.style.maxHeight = "0";
        menu.classList.remove("active");
      });

      document.querySelectorAll("header .item-w-child").forEach(i => {
        i.classList.remove("active");
      });

      // Open this one
      const subMenu = this.parentElement.querySelector(".sub-menu");
    
      if (subMenu) {
        const scrollHeight = subMenu.scrollHeight; // actual inner content height
        subMenu.style.maxHeight = scrollHeight + "px";
        subMenu.classList.add("active");
        this.classList.add("active");

        toggleOverlay();

      }
    });
  });

  // Optional: collapse menus when mouse leaves header
  const header = document.querySelector("header .header__primary-nav");
  if (header) {
    header.addEventListener("mouseleave", () => {
      document.querySelectorAll("header .sub-menu").forEach(menu => {
        menu.style.maxHeight = "0";
        menu.classList.remove("active");
      });
      document.querySelectorAll("header .item-w-child").forEach(i => {
        i.classList.remove("active");
      });
      toggleOverlay()
    });
  }
});

function toggleMobileMenu() {
  
  const menu = document.querySelector('section.mobile-menu');
  if (!menu) return; // exit if element not found

  if (menu.classList.contains('open')) {
    menu.classList.remove('open');
  } else {
    menu.classList.add('open');
  }
}



// Mobile menu accordion
document.addEventListener('DOMContentLoaded', function() {
  const mobileMenuButtons = document.querySelectorAll('.item-w-child-mobile');

  mobileMenuButtons.forEach(button => {
    button.addEventListener('click', function() {
      const parent = button.closest('.item-with-subs-wrap');
      const subMenu = parent.querySelector('.sub-menu');

      // Close all other sub-menus
      document.querySelectorAll('.mobile-menu .sub-menu').forEach(sm => {
        if (sm !== subMenu) {
          sm.style.maxHeight = '0';
          sm.parentElement.querySelector('.item-w-child-mobile').setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle the clicked sub-menu
      if (subMenu.style.maxHeight && subMenu.style.maxHeight !== '0px') {
        subMenu.style.maxHeight = '0';
        button.setAttribute('aria-expanded', 'false');
      } else {
        subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header");
  if (!header) return;

  let lastScrollY = window.scrollY;

  window.addEventListener("scroll", function () {
    const currentScroll = window.scrollY;

    if (currentScroll > lastScrollY && currentScroll >= 150) {
      // scrolling down past 150px
      header.classList.add("solid-b");
    } else if (currentScroll < lastScrollY) {
      // scrolling up
      header.classList.remove("solid-b");
    }

    lastScrollY = currentScroll;
  });
});

